import React, {useEffect, useState} from "react";
import FieldErrorMessage from "../../Utils/FieldErrorMessage";
import {MdDeleteOutline} from "react-icons/md";
import {FaRegEdit} from "react-icons/fa";
import {isAdmin, translateToBanglaDigit} from "../../../helpers/helpers";
import Pagination from "../../Utils/Pagination";

const Ministry = ({handleSubmit, onSubmit, errors, register, setValue, data, from, currentPage, totalPages, setCurrentPage, getMinistryOrganizationAndInstitution, handleDelete, handleEdit, permissions}) => {

    useEffect(() => {
        setValue('type', 'ministry');
    }, [])

    const [selectedMinistry, setSelectedMinistry] = useState('');
    const handleChange = (value) => {
        setSelectedMinistry(value);
    }

    useEffect(() => {
        if (selectedMinistry) {
            getMinistryOrganizationAndInstitution('ministry', '', selectedMinistry);
        }

    }, [selectedMinistry, currentPage]);

    return (
        <>
            <div className='card shadow border-0 mt-2'>
                <div className='card-body'>
                    <div className="row">
                        <div className="col-4">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="col-8">
                                        <label htmlFor="ministry" className="form-label">মন্ত্রণালয়ের ধরন<span
                                            className='text-danger'> *</span></label>
                                        <select className="form-select"
                                                aria-label="Default select example" {...register('ministry_type')}>
                                            <option value="">মন্ত্রণালয় নির্বাচন করুন</option>
                                            <option value="1">শিল্প মন্ত্রণালয়</option>
                                            <option value="2">অন্যান্য মন্ত্রণালয়</option>
                                        </select>
                                        <FieldErrorMessage errors={errors} name='ministry_type'/>
                                    </div>
                                    <div className="col-8 mt-2">
                                       <label htmlFor="phone" className="form-label">নাম <span
                                            className='text-danger'>*</span></label>
                                        <input type="text" className="form-control"
                                               {...register("name")}/>
                                        <FieldErrorMessage errors={errors} name='name'/>
                                        <br/>
                                        <button className="btn btn-sm btn-success">সংরক্ষণ করুন</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-8">
                            <select className="form-select" onChange={(e) => handleChange(e.target.value)}>
                                <option value="">মন্ত্রণালয় নির্বাচন করুন</option>
                                <option value="1">শিল্প মন্ত্রণালয়</option>
                                <option value="2">অন্যান্য মন্ত্রণালয়</option>

                            </select>
                            <div className='table-responsive pt-4'>
                                <table className="table table-bordered table-hover">
                                    <thead>
                                    <tr style={{backgroundColor: '#f9f9f9'}}>
                                        <th scope="col" style={{textAlign: 'center'}}>ক্রমিক নং</th>
                                        <th scope="col">নাম</th>
                                        <th scope="col">এন্ট্রিকৃত ডাটা</th>
                                        <th scope="col">অ্যাকশন</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        data && data.map((ministry, index) => {
                                            return (
                                                <tr>
                                                    <td style={{textAlign: 'center'}}>{translateToBanglaDigit(index + from)}</td>
                                                    <td>{ministry.name}</td>
                                                    <td className="text-center">{translateToBanglaDigit(ministry?.ministry_employees_count)}</td>

                                                    <td>
                                                        <div>
                                                            {
                                                                (isAdmin() || permissions?.includes('edit')) &&
                                                                <button className="btn btn-sm btn-secondary"
                                                                        onClick={() => handleEdit(ministry)}>
                                                                    <FaRegEdit/>
                                                                </button>
                                                            }
                                                            {/* &nbsp;
                                                            {
                                                                (isAdmin() || permissions?.includes('delete')) &&
                                                                <button className="btn btn-sm btn-secondary"
                                                                        onClick={() => handleDelete(ministry.id)}>
                                                                    <MdDeleteOutline/>
                                                                </button>
                                                            } */}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                                <br></br>
                                <Pagination currentPage={currentPage} totalPages={totalPages}
                                            onPageChange={setCurrentPage}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Ministry;